import type { JSX } from 'react';
import type { WireArtifact } from '@logistics/contracts';
import { amount } from '@/lib/format';
import { caption } from './parts';

type Kpi = Extract<WireArtifact, { kind: 'kpi' }>;

/** The design's stat tiles: a headline number over a mono label, two to a row. */
export function KpiArtifact({ artifact }: { artifact: Kpi }): JSX.Element {
  return (
    <div className="grid grid-cols-2 gap-2.5">
      {artifact.items.map((item, i) => (
        <div key={i} className="border-line bg-surf min-w-0 rounded-xl border px-3.5 py-3">
          <div className="truncate font-mono text-[19px] font-medium tabular-nums">
            {amount(item.value)}
          </div>
          <div className={`${caption} mt-1 truncate`}>{item.label.toUpperCase()}</div>
        </div>
      ))}
    </div>
  );
}
